import { type DragEvent, FC } from 'react'

import { Button, Tooltip } from '@sequencehq/core-components'

import { useResolvedNodeDefinitions } from 'Automations/automationEditor/atoms'
import { NodeType } from 'Automations/nodeDefinitions/types'

/**
 * The node icon button shared by the bottom AddNodeToolbar and the node picker
 * bars (inline edge insert + connection drop): a tooltipped, unstyled button
 * showing the node type's icon. Behaviour — click, hover, drag — is supplied by
 * the caller; this owns only the consistent presentation.
 */
export const NodeIconButton: FC<{
  nodeType: NodeType
  'data-testid': string
  onClick: () => void
  onMouseEnter?: () => void
  draggable?: boolean
  onDragStart?: (event: DragEvent) => void
  onDragEnd?: (event: DragEvent) => void
}> = ({
  nodeType,
  'data-testid': dataTestId,
  onClick,
  onMouseEnter,
  draggable,
  onDragStart,
  onDragEnd
}) => {
  const definition = useResolvedNodeDefinitions()[nodeType]
  const Icon = definition.icon

  return (
    <Tooltip label={definition.name}>
      <Button
        data-testid={dataTestId}
        variant="unstyled"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        draggable={draggable}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
      >
        <Icon boxSize="32px" />
      </Button>
    </Tooltip>
  )
}
